import axios, { setAuthorization } from "../config/axios";
import { decryptMessage, encryptMessage } from "../encryptAndDecrypt";
import CryptoJS from 'crypto-js';
import { getAuthToken } from "../lib/localStorage";

export const getAllCMSData = async () => {
  try {
    let respData = await axios({
      method: "post",
      url: `/settings/get-cms`,
    });

    return {
      status: respData.data.status,
      loading: false,
      message: respData.data.message,
      result: respData.data.data,
    };
  } catch (err) {
    return {
      status: false,
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
      data: null,
    };
  }
};

export const getSettingsData = async () => {
  try {
    let respData = await axios({
      method: "post",
      url: `/settings/getSiteSetting`,
    });

    return {
      status: respData.data.status,
      loading: false,
      message: respData.data.message,
      result: respData.data.data,
    };
  } catch (err) {
    return {
      status: false,
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
      data: null,
    };
  }
};

export const createLandingHeaderContent = async (data) => {
  try {
    const value = encryptMessage(data.data)
    let respData = await axios({
      method: "post",
      url: `/admin/createLandingCmsContent`,
      data: { data: value }
    });
    const decryptData = decryptMessage(respData.data)
    if (decryptData.status == true && decryptData.statusCode == 200) {

      return {
        data: decryptData.data,
        status: decryptData.status,
        message: decryptData.message,
        loading: true,
        statusCode: decryptData.statusCode

      }
    } else {
      return {
        data: decryptData.data,
        status: decryptData.status,
        message: decryptData.message,
        loading: false,
        statusCode: decryptData.statusCode

      }
    }

  } catch (err) {
    return {
      status: false,
      message: "Something went worng",
      loading: false,
      statusCode: 500

    }
  }
};

export const getAllLandingHeaderContent = async (data) => {
  try {
    const value = encryptMessage(data)
    let respData = await axios({
      method: "post",
      url: `/admin/getAllLandingHeaderContent`,
      data: { data: value }
    });
    const decryptData = decryptMessage(respData.data);
    if (decryptData.status == true && decryptData.statusCode == 200) {

      return {
        data: decryptData.data,
        status: decryptData.status,
        message: decryptData.message,
        loading: true,
        statusCode: decryptData.statusCode

      }
    } else {
      return {
        data: decryptData.data,
        status: decryptData.status,
        message: decryptData.message,
        loading: false,
        statusCode: decryptData.statusCode

      }
    }

  } catch (err) {
    return {
      status: false,
      message: "Something went worng",
      loading: false,
      statusCode: 500

    }
  }
};

export const editLandingHeaderContent = async (data) => {
  try {
    const value = encryptMessage(data)
    let respData = await axios({
      method: "post",
      url: `/admin/editLandingHeaderContent`,
      data: { data: value }
    });
    const decryptData = decryptMessage(respData.data);
    if (decryptData.status == true && decryptData.statusCode == 200) {

      return {
        data: decryptData.data,
        status: decryptData.status,
        message: decryptData.message,
        loading: true,
        statusCode: decryptData.statusCode

      }
    } else {
      return {
        data: decryptData.data,
        status: decryptData.status,
        message: decryptData.message,
        loading: false,
        statusCode: decryptData.statusCode

      }
    }

  } catch (err) {
    return {
      status: false,
      message: "Something went worng",
      loading: false,
      statusCode: 500

    }
  }
};


export const listOfCms = async () => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/listOfCms`,
    });
    const decryptData = decryptMessage(respData.data);
    if (decryptData.status == true && decryptData.statusCode == 200) {

      return {
        data: decryptData.data,
        status: decryptData.status,
        message: decryptData.message,
        loading: true,
        statusCode: decryptData.statusCode

      }
    } else {
      return {
        data: decryptData.data,
        status: decryptData.status,
        message: decryptData.message,
        loading: false,
        statusCode: decryptData.statusCode

      }
    }

  } catch (err) {
    return {
      status: false,
      message: "Something went worng",
      loading: false,
      statusCode: 500

    }
  }
};



export const socialMediaLink = async (data) => {
  try {
    const value = encryptMessage(data)
    let respData = await axios({
      method: "post",
      url: `/admin/socialMediaLink`,
      data: { data: value }
    });
    const decryptData = decryptMessage(respData.data);
    if (decryptData.status == true && decryptData.statusCode == 200) {

      return {
        data: decryptData.data,
        status: decryptData.status,
        message: decryptData.message,
        loading: true,
        statusCode: decryptData.statusCode

      }
    } else {
      return {
        data: decryptData.data,
        status: decryptData.status,
        message: decryptData.message,
        loading: false,
        statusCode: decryptData.statusCode

      }
    }

  } catch (err) {
    return {
      status: false,
      message: "Something went worng",
      loading: false,
      statusCode: 500

    }
  }
};


export const getSocialMedaiLink = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/getSocialMedaiLink`,
    });
    const decryptData = decryptMessage(respData.data);
    if (decryptData.status == true && decryptData.statusCode == 200) {

      return {
        data: decryptData.data,
        status: decryptData.status,
        message: decryptData.message,
        loading: true,
        statusCode: decryptData.statusCode

      }
    } else {
      return {
        data: decryptData.data,
        status: decryptData.status,
        message: decryptData.message,
        loading: false,
        statusCode: decryptData.statusCode

      }
    }

  } catch (err) {
    return {
      status: false,
      message: "Something went worng",
      loading: false,
      statusCode: 500

    }
  }
};

export const subscribeData = async (data) => {
  try {
    const value = encryptMessage(data);
       
    let respData = await axios({
      method: "post",
      url: `/admin/subscribeList`,
      data: { data: value }
    });
    
    const decryptData = decryptMessage(respData.data);
    if (decryptData.status == true && decryptData.statusCode == 200) {

      return {
        data: decryptData.data,
        status: decryptData.status,
        message: decryptData.message,
        loading: true,
        statusCode: decryptData.statusCode

      }
    } else {
      return {
        data: decryptData.data,
        status: decryptData.status,
        message: decryptData.message,
        loading: false,
        statusCode: decryptData.statusCode

      }
    }

  } catch (err) {
    return {
      status: false,
      message: "Something went worng",
      loading: false,
      statusCode: 500

    }
  }
};
